import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-filter-accordion',
  templateUrl: './filter-accordion.html',
  imports: [TranslatePipe],
})
export class filterAccordion {
  //region Inputs
  // Name of the filter
  public readonly filterName = input.required<string>()
  //endregion Inputs

  //region Properties
  protected isAccordionOpen = false
  //endregion Properties

  //region Methods
  toggleAccordion(): void {
    this.isAccordionOpen = !this.isAccordionOpen
  }
}
